import { useCheckout } from '@/contexts/checkoutContext';
import * as Styled from './Promotions.styled';

export const Promotions = () => {
    const { checkoutData: { promotions }} = useCheckout();
  return (
    <Styled.Container>
      {promotions?.map(promotion => (
        <p key={promotion.text}>{promotion.text}</p>
      ))}
    </Styled.Container>
  );
};
